import { List, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const FacilityMarketingNavItems = (props) => {
	const { selectedFacility } = props
	const classes = useStyles()

	const facilityId = selectedFacility ? selectedFacility._id : null

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${facilityId}/facilityMarketing/events`}>
				<ListItemText primary="Events & Specials" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${facilityId}/facilityMarketing/bar`}>
				<ListItemText primary="Featured Bar Items" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${facilityId}/facilityMarketing/friendsOfSkiptown`}>
				<ListItemText primary="Friends of Skiptown" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${facilityId}/facilityMarketing/dashNotifications`}>
				<ListItemText primary="Dash Notifications" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${facilityId}/facilityMarketing/promos`}>
				<ListItemText primary="Promos" />
			</ListItem>
			<div style={{ height: 600, width: 10 }}></div>
		</List>
	)
}

export default FacilityMarketingNavItems
